<template>
  <div class="b-menu-pagination" :style="[size]">
    <slot v-if="$scopedSlots.paginationActions" name="paginationActions" v-bind="_slotBindings"></slot>

    <b-menu-pagination-actions :has-previous="hasPrevious" :has-next="hasNext" @click:previous="previous" @click:next="next" v-else>
      <template #previous><b-menu-pagination-actions-prev></b-menu-pagination-actions-prev></template>
      <template #next><b-menu-pagination-actions-next></b-menu-pagination-actions-next></template>
    </b-menu-pagination-actions>
  </div>
</template>

<script>
import BMenuPaginationActions from './b-menu-pagination-actions'
import BMenuPaginationActionsPrev from './b-menu-pagination-actions-prev'
import BMenuPaginationActionsNext from './b-menu-pagination-actions-next'

import StoreHelper from '../store/helper'

import _ from 'lodash'

export default {
  name: 'b-menu-pagination',
  components: {
    BMenuPaginationActions,
    BMenuPaginationActionsNext,
    BMenuPaginationActionsPrev
  },
  props: {
    value: {
      type: Number,
      required: true
    },
    count: {
      type: Number,
      required: true
    }
  },
  methods: {
    previous () { this._page-- },
    next () { this._page++ }
  },
  computed: {
    _page: {
      get () { return this.value },
      set (page) { this.$emit('input', page) }
    },
    size () {
      return { width: `${StoreHelper.getMenuMainBubbleSize()}px`, height: `${StoreHelper.getMenuMainBubbleSize()}px` }
    },
    _slotBindings () {
      return {
        previous: this.previous,
        hasPrevious: this.hasPrevious,
        next: this.next,
        hasNext: this.hasNext
      }
    },
    hasNext () {
      return _.lt(0, this.count - (this._page + 1) * StoreHelper.getMaxItemsPerPage())
    },
    hasPrevious () {
      return _.gt(this._page, 0)
    }
  }
}
</script>

<style lang="scss" scoped>
.b-menu-pagination {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  margin: auto;
  z-index: 1;
  pointer-events: none;
}
</style>
